export const formContent = {
  DE: {
    submitTitle: "Feedback absenden",
    acceptPolicy: "Ich akzeptiere die",
    privacyPolicy: "Datenschutzerklärung",
    overallRating: "Wie sieht Ihre Gesamtbewertung aus?",
    namedTab: "Namentlich",
    anonymousTab: "Anonym",
    dataTitle: "Bitte geben Sie ihre Daten ein",
    emailPlaceholder: "Email",
    firstNamePlaceholder: "Vorname",
    lastNamePlaceholder: "Nachname",
    submitError: "Bitte stimmen Sie der Datenschutzerklärung zu.",
    feedbackNotFound: "Feedback-Formular nicht gefunden.",
    answerPlaceholder: "Geben Sie hier Ihre Antwort ein...",
    titleP: "Erfolgreich gesendet!",
    googleTitle: "Hat Ihnen unser Service gefallen?",
    googleDescription: "Wir würden uns über Ihre Bewertung freuen!",
    googleCta: "Jetzt auf Google bewerten",
    googleNote: "Ihre Meinung hilft uns, unseren Service zu verbessern",
    titleF: "Das hat leider nicht geklappt!",
    defaultMessage: "Beim Absenden des Feedbacks ist ein Fehler aufgetreten.",
    allQuestionsRequired: "Bitte beantworten Sie alle Fragen.",
    fillOutNameEmail: "Bitte geben Sie ihre persönlichen Daten ein.",
    chooseYesNoPlaceholder: "Bitte geben Sie ihre Antwort ein.",
  },
  EN: {
    submitTitle: "Submit Feedback",
    acceptPolicy: "I accept the",
    privacyPolicy: "privacy policy",
    overallRating: "What is your overall rating?",
    namedTab: "Named",
    anonymousTab: "Anonymous",
    dataTitle: "Please enter your information",
    emailPlaceholder: "Email",
    firstNamePlaceholder: "First name",
    lastNamePlaceholder: "Last name",
    submitError: "Please accept privacy policy.",
    feedbackNotFound: "Feedback form not found.",
    answerPlaceholder: "Enter your answer here...",
    title: "Successfully submitted!",
    googleTitle: "Did you like our service?",
    googleDescription: "We would appreciate your review!",
    googleCta: "Leave a review on Google",
    googleNote: "Your opinion helps us improve our service",
    title: "Something went wrong!",
    defaultMessage: "An error occurred while submitting your feedback.",
    allQuestionsRequired: "Please answer all questions.",
    fillOutNameEmail: "Please enter your personal information.",
    chooseYesNoPlaceholder: "Please enter your answer",
  },
};
